import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseDropdown from '@/components/BaseDropdown.vue';
import PhoneInput from '@/components/Inputs/PhoneInput.vue';
import Card from '@/components/Cards/Card.vue';
import Modal from '@/components/Modal.vue';
import StatsCard from '@/components/Cards/StatsCard.vue';
import BaseButton from '@/components/BaseButton.vue';
import Badge from '@/components/Badge.vue';
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue';
import BaseSwitch from '@/components/BaseSwitch.vue';
import BaseRadio from '@/components/Inputs/BaseRadio';
import BaseProgress from '@/components/BaseProgress';
import BasePagination from '@/components/BasePagination';
import BaseAlert from '@/components/BaseAlert';
import CountDownAlert from '@/components/CountDownAlert';
import BaseNav from '@/components/Navbar/BaseNav';
import BaseHeader from '@/components/BaseHeader';
import OrgPartsTable from '@/components/Table/OrgPartsTable';

import FuzzySearch from '@/components/FuzzySearch/FuzzySearch.vue';
import GridHealth from '@/components/GridHealth/GridHealth.vue';
import SetLocation from '@/components/Maps/SetLocation.vue';
import SensorsUpdateModal from '@/components/Modal/SensorsUpdateModal.vue';
import FarmHealth from '@/components/GridHealth/FarmHealth.vue';
import FarmPicker from '@/components/Pickers/FarmPicker.vue';
import AutoComplete from '@/components/AutoComplete.vue';
import FormAddress from '@/components/Forms/FormAddress.vue';
import FormFarm from '@/components/Forms/FormFarm.vue';
import FormGroup from '@/components/Forms/FormGroup.vue';
import FormOrganisation from '@/components/Forms/FormOrganisation.vue';
import FormSensor from '@/components/Forms/FormSensor.vue';


import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Input, Tooltip, Popover, InputNumber, Button, ButtonGroup, Collapse, CollapseItem } from 'element-ui';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(CountDownAlert.name, CountDownAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(PhoneInput.name, PhoneInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(OrgPartsTable.name, OrgPartsTable);
    Vue.component(Modal.name, Modal);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(RouteBreadcrumb.name, RouteBreadcrumb);

    Vue.component(FuzzySearch.name, FuzzySearch);
    Vue.component(GridHealth.name, GridHealth);
    Vue.component(FarmHealth.name, FarmHealth);
    Vue.component(FarmPicker.name, FarmPicker);
    Vue.component(AutoComplete.name, AutoComplete);
    Vue.component(SetLocation.name, SetLocation);
    Vue.component(SensorsUpdateModal.name, SensorsUpdateModal);
    Vue.component(FormAddress.name, FormAddress);
    Vue.component(FormFarm.name, FormFarm);
    Vue.component(FormGroup.name, FormGroup);
    Vue.component(FormSensor.name, FormSensor);
    Vue.component(FormOrganisation.name, FormOrganisation);

    Vue.component(Input.name, Input);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.use(Button);
    Vue.use(ButtonGroup);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(InputNumber);
    Vue.use(Tooltip);
    Vue.use(Popover);
  }
};

export default GlobalComponents;
